export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-se_se.091bc228.png";